import { useQuery } from "@tanstack/react-query";
import { getCurrentCourse, putCurrentCourse } from "@/api/Api";

export const useCurrentCourse = () => {
  const currentCourseQuery = useQuery({
    queryKey: ["currentCourse"],
    queryFn: () => getCurrentCourse(),
  });

  const handleSelectCourse = (courseId: number) => {
    putCurrentCourse({ courseId });
    currentCourseQuery.refetch();
  };

  return {
    currentCourseID: currentCourseQuery.data?.courseId,
    isCurrentCourseLoading: currentCourseQuery.isLoading,
    setCurrentCourseID: handleSelectCourse,
  };
};
